import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IUpdateContractInsurance } from "mobx-stores/_models/employee/contract-insurance";
import { number, string } from "yup";
import {
  searchEmploymentContractTermTypeOptions,
  searchEmploymentContractTypeOptions,
} from "../auto-complete-options";
export const getContractInsuranceFormSchema =
  (): ObjectSchemaType<IUpdateContractInsurance> => ({
    contractType: {
      label: "Loại HĐ",
      type: InputType.autoComplete,
      gridSize: 6,
      validattionYupSchema: number(),
      metaData: {
        searchOptionItemsAsync: searchEmploymentContractTypeOptions,
      },
    },
    contractTermType: {
      label: "Kỳ Hạn",
      type: InputType.autoComplete,
      gridSize: 6,
      validattionYupSchema: number(),
      metaData: {
        searchOptionItemsAsync: searchEmploymentContractTermTypeOptions,
      },
    },
    contractNumber: {
      label: "Số HĐ",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string().max(50).required(),
    },
    contractSigningDate: {
      label: "Ngày Ký",
      type: InputType.datePicker,
      gridSize: 6,
      validattionYupSchema: string().required(),
    },
    contractExpirationDate: {
      label: "Ngày ĐH",
      type: InputType.datePicker,
      gridSize: 6,
      validattionYupSchema: string(),
    },
    contractNote: {
      label: "Ghi Chú HĐ",
      type: InputType.textArea,
      gridSize: 12,
      validattionYupSchema: string().max(1024),
    },
    socialInsuranceNumber: {
      label: "Số BHXH",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string().max(50),
    },
    healthInsuranceNumber: {
      label: "Số BHYT",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string().max(50),
    },
    kcbPlace: {
      label: "Nơi KCB",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string(),
    },
    insurancePaymentDate: {
      label: "Thời Điểm Đóng",
      type: InputType.datePicker,
      gridSize: 6,
      validattionYupSchema: string(),
    },
    insuranceNote: {
      label: "Ghi Chú BH",
      type: InputType.textArea,
      gridSize: 12,
      validattionYupSchema: string().max(1024),
    },
    cdJoiningDate: {
      label: "Ngày Tham Gia CĐ",
      type: InputType.datePicker,
      gridSize: 6,
      validattionYupSchema: string(),
    },
    personalTaxID: {
      label: "MST Cá Nhân",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string().max(50),
    },
    note: {
      label: "Ghi Chú",
      type: InputType.textArea,
      gridSize: 12,
      validattionYupSchema: string().max(1024),
    },
  });
